import budget from '../../en/pages/budget';

export default {
    ...budget,
    filters: {
        ...budget.filters,
        minAmount: "Min amount ($)",
        maxAmount: "Max amount ($)"
    }
};
